import React, { Component }          from 'react';

import "./Index.scss";

const __html = require('../static-frontpage/index.html.js');
const template = { __html: __html };

class Index extends Component {
  render() {
    return (
      <div style={{width: '100%', height: '100%', overflow: 'scroll', background: 'white'}} className="index__container">
        <div dangerouslySetInnerHTML={template} />
      </div>
    );
  }
}

export default Index;